import { Provider } from './provider';

export class ProviderSelectDialog {
  excludeProviderIds: Array<string>;
  customerID?:string
}
